import { AvailableLanguages } from '@repo/toolkit/language-types'
import { TFunction } from 'i18next'
import { z, ZodType } from 'zod'

import { LanguageEnum } from '../../../../lib/types/enums/languages/language.enum'
import { LanguageLevelEnum } from '../../../../lib/types/enums/languages/language-level.enum'
import { ContactViaEnum } from '../../../../lib/types/enums/score-cards/contact-via.enum'
import { EvalutationEnum } from '../../../../lib/types/enums/staff-application/evalutation.enum'
import { ScoreCardInput } from '../../../../lib/types/models/score-card/score-card-input'
import { NullableTransformer } from '../../../../lib/types/utils'
import { createDateStringSchema } from '../../../../lib/utils/validations/date.validation'
import { createEnumSchema } from '../../../../lib/utils/validations/enum-validation'
import { FILE_VALIDATION } from '../../../../lib/utils/validations/file.validation'
import {
  createNumberArraySchema,
  createNumberSchema
} from '../../../../lib/utils/validations/int-array-validation'
import { PHONE_NUMBER_SCHEMA } from '../../../../lib/utils/validations/phone-number.validation'
import { createStringSchema } from '../../../../lib/utils/validations/string-validation'

export const scoreCardSchema = (
  t: TFunction<AvailableLanguages, undefined>
): ZodType<NullableTransformer<ScoreCardInput>> =>
  z.object({
    // candidate details
    email: createStringSchema('adresse email', { isEmail: true }),
    phoneNumber: PHONE_NUMBER_SCHEMA(t),
    firstContactDate: createDateStringSchema({ inputName: 'date de premier contact' }).nullish(),
    firstContactVia: createEnumSchema({
      fieldName: 'via',
      enumType: ContactViaEnum,
      nullish: true
    }),
    secondContactDate: createDateStringSchema({ inputName: 'date de deuxième contact' }).nullish(),
    secondContactVia: createEnumSchema({
      fieldName: 'via',
      enumType: ContactViaEnum,
      nullish: true
    }),
    thirdContactDate: createDateStringSchema({ inputName: 'date de troisième contact' }).nullish(),
    thirdContactVia: createEnumSchema({
      fieldName: 'via',
      enumType: ContactViaEnum,
      nullish: true
    }),
    classifiedDate: createDateStringSchema({
      inputName: 'date de classement sans suite'
    }).nullish(),

    // interview details
    interviewStartDate: createDateStringSchema({ inputName: 'date' }).nullish(),
    interviewStartHour: createNumberSchema('heure', { nullish: true }),
    interviewStartMinute: createNumberSchema('minute', { nullish: true }),
    transcript: FILE_VALIDATION().nullish(),
    video: FILE_VALIDATION().nullish(),

    // evaluation
    presentation: createEnumSchema({
      fieldName: 'présentation',
      enumType: EvalutationEnum,
      nullish: true
    }),
    ponctuality: createEnumSchema({
      fieldName: 'ponctualité',
      enumType: EvalutationEnum,
      nullish: true
    }),
    motivation: createEnumSchema({
      fieldName: 'motivation',
      enumType: EvalutationEnum,
      nullish: true
    }),
    senseOfResponsability: createEnumSchema({
      fieldName: 'sens des responsabilités',
      enumType: EvalutationEnum,
      nullish: true
    }),
    relevanceOfAnswer: createEnumSchema({
      fieldName: 'pertinence des réponses',
      enumType: EvalutationEnum,
      nullish: true
    }),
    elocution: createEnumSchema({
      fieldName: 'élocution',
      enumType: EvalutationEnum,
      nullish: true
    }),
    reactivity: createEnumSchema({
      fieldName: 'réactivité',
      enumType: EvalutationEnum,
      nullish: true
    }),
    globalAppreciation: createEnumSchema({
      fieldName: 'appréciation globale',
      enumType: EvalutationEnum,
      nullish: true
    }),
    levelOfLanguages: z.array(
      z.object({
        language: createEnumSchema({ fieldName: 'langue', enumType: LanguageEnum }),
        level: createEnumSchema({ fieldName: 'niveau', enumType: LanguageLevelEnum })
      })
    ),
    hobbies: createNumberArraySchema('loisirs'),
    doesHaveAPeculiarTalent: createStringSchema('talent particulier', { nullish: true }),
    doesKnowLECPerson: createStringSchema('personne connue', { nullish: true }),
    comments: createStringSchema('commentaires', { nullish: true }),
    isApplicantRecommendedForHire: z.boolean().nullish()
  })
